// Vite-injected environment variables. Defaults match the local dev proxy.
// Production values come from Cloudflare Pages env at build time.

export const API_BASE = import.meta.env.VITE_API_BASE || ''
export const BOT_USERNAME = import.meta.env.VITE_BOT_USERNAME || 'bitrixtsk_bot'
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || ''
export const IS_DEV = import.meta.env.DEV
